import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const append = (source, element) => {
    async function* iterator() {
        yield* source;
        yield element;
    }
    return new BasicAsyncEnumerable(iterator);
};
